module.exports = __webpack_public_path__ + "img/case_bjdx.6e15de89.png";